import { render, staticRenderFns } from "./PayableReceivablePartialPayment.vue?vue&type=template&id=223f3f4d&scoped=true&"
import script from "./PayableReceivablePartialPayment.vue?vue&type=script&lang=js&"
export * from "./PayableReceivablePartialPayment.vue?vue&type=script&lang=js&"
import style0 from "./PayableReceivablePartialPayment.vue?vue&type=style&index=0&id=223f3f4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f3f4d",
  null
  
)

export default component.exports